import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { dialogs, saving, i18next } from '@yola/ws-sdk';
import { saveSiteWithEffect } from 'src/js/modules/saving/helpers/save-site';
import dialogTypes from '../../dialogs/constants/dialog-types';

export default function useCheckForUnsafe() {
  const savingStatus = useSelector(saving.selectors.getStatus);

  return useCallback(
    ({ onSubmit, onCancel }) =>
      (...args) => {
        const { UNSAVED, ERROR } = saving.constants.statuses;

        if (savingStatus !== UNSAVED && savingStatus !== ERROR) {
          onSubmit(...args);
          return;
        }

        dialogs.operations.show(dialogTypes.CONFIRM_DIALOG, {
          onCancel: () => {
            if (onCancel) onCancel(...args);
          },
          onSubmit: async () => {
            await saveSiteWithEffect(async () => {
              onSubmit(...args);
            });
          },
          captions: {
            title: i18next.t('Save site?'),
            description: i18next.t('Your site has unsaved changes. Save them to proceed.'),
            submit: i18next.t('Submit'),
            cancel: i18next.t('Cancel'),
          },
        });
      },
    [savingStatus]
  );
}
